import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@siliconx/shared/ui/PageHeader';
import { Card } from '@siliconx/shared/ui/Card';
import { PrivacyPolicyContent } from '../components/legal/PrivacyPolicyContent';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPolicyPage,
});

/**
 * Static privacy policy page, mirrored from docs/legal/privacy-policy.md.
 * The two must stay in sync — the body lives in
 * components/legal/PrivacyPolicyContent.tsx (SIL-1057: shared with
 * SignupFrame's in-page panel, since a signed-out referral visitor never
 * reaches this authenticated route) as hardcoded JSX (no markdown renderer
 * is a dependency of this app), so any edit to the policy needs both files
 * updated.
 */
function PrivacyPolicyPage() {
  return (
    <div className="mx-auto max-w-3xl">
      <div className="mb-6">
        <PageHeader title="Privacy Policy" subtitle="Effective date: October 2, 2026" />
      </div>

      <Card className="space-y-6 text-sm text-foreground">
        <PrivacyPolicyContent />
      </Card>
    </div>
  );
}
